import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AuthRedirect = () => {
  const { currentUser, userRole, userCategory, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading) {
      if (currentUser) {
        // Prefer category, fall back to legacy role
        if (userCategory === 'admin' || userRole === 'admin') {
          navigate('/admin-dashboard');
        } else if (userCategory === 'employee' || userRole === 'project_manager' || userRole === 'employee') {
          navigate('/employee-dashboard');
        } else if (userCategory === 'client' || userRole === 'client') {
          navigate('/client-dashboard');
        } else {
          navigate('/unauthorized');
        }
      } else {
        navigate('/auth/login');
      }
    }
  }, [currentUser, userRole, userCategory, loading, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  return null;
};

export default AuthRedirect;
